import React from 'react';
import styled from 'styled-components';

const Label = styled.label`
  position: relative;
  display: inline-block;
  width: 40px;
  height: 25px;
  font-family: 'Montserrat Medium';
  margin: 0;

  input {
    opacity: 0;
    width: 0;
    height: 0;
  }

  .slider {
    position: absolute;
    cursor: pointer;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: var(--grey-10, #E4E5E7);
    -webkit-transition: 0.4s;
    transition: 0.4s;
    width: 40px;
    border-radius: 12px;
    padding: 2px;
  }

  .slider:before {
    position: absolute;
    content: '';
    height: 17px;
    width: 17px;
    left: 4px;
    bottom: 4px;
    background-color: white;
    -webkit-transition: 0.4s;
    transition: 0.4s;
  }

  input:checked + .slider {
    background-color: var(--blue-50, #0095FF);
  }

  input:focus + .slider {
    box-shadow: none;
  }

  input:checked + .slider:before {
    -webkit-transform: translateX(15px);
    -ms-transform: translateX(15px);
    transform: translateX(15px);
  }

  /* Rounded sliders */
  .slider.round {
    border-radius: 35px;
  }

  .slider.round:before {
    border-radius: 50%;
  }
`;

export const ToggleSwitch = ({
  style,
  children,
  status,
  onClick,
  fontFamily = '',
  className
}) => {
  return (
    <div style={{ display: 'flex', alignItems: 'center', ...style }} className={className}>
      {children && (
        <span
          style={{
            marginRight: '10px',
            color: 'var(--grey-95, #0C0D0D)',
            fontFamily: fontFamily || 'Montserrat Medium',
          }}
        >
          {children}
        </span>
      )}
      <Label
        style={{ height: 24 }}
        onClick={(e) => {
          e.preventDefault();
          onClick();
        }}
      >
        <input type="checkbox" checked={status} readOnly />
        <span className="slider round"></span>
      </Label>
    </div>
  );
};
